import React from 'react';
import { Typography } from '@mui/material';
import { CheckIcon } from '@components/icons/svg-icon.tsx';
import {
  StatusLozengeProps,
  StatusLozengeToneEnum
} from '@modules/digital-signage/model/group-settings.model.ts';
import { STATUS_LOZENGE_TONES } from '@modules/digital-signage/utils/digital-signage.utils.ts';

const StatusLozenge: React.FC<StatusLozengeProps> = ({
  tone,
  label,
  className = ''
}) => (
  <Typography
    variant="caption"
    component="span"
    className={`inline-flex! items-center gap-1.25 h-5.5 px-2 rounded-full text-[11px]! font-semibold! leading-none! whitespace-nowrap shrink-0 ${STATUS_LOZENGE_TONES[tone]} ${className}`}
  >
    {tone === StatusLozengeToneEnum.BrandSoft ? (
      <CheckIcon
        viewBox="0 0 9 7"
        className="w-2.5! h-2! [&_path]:stroke-current"
      />
    ) : (
      <span
        className={`w-1.5 h-1.5 rounded-full bg-current ${
          tone === StatusLozengeToneEnum.Brand
            ? 'motion-safe:animate-pulse'
            : ''
        }`}
      />
    )}
    {label}
  </Typography>
);

export default StatusLozenge;
